import { render } from "./UpdateMenuModifierItem.vue?vue&type=template&id=0db79d58&scoped=true"
import script from "./UpdateMenuModifierItem.vue?vue&type=script&lang=js"
export * from "./UpdateMenuModifierItem.vue?vue&type=script&lang=js"

import "./UpdateMenuModifierItem.vue?vue&type=style&index=0&id=0db79d58&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db79d58"]])

export default __exports__